import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initial: 'C',
  color: 'bg-blue-100 text-blue-700',
  name: 'Claudia M.',
  location: 'Mendoza',
  child: 'Mamá de Agustín, 9 años',
  text: 'Tres años escuchándolo silabear cada noche. Tres años sintiéndome mal madre por no saber cómo ayudarlo. En la segunda semana con el Tomo 3 lo escuché leer una oración entera sin parar. Me fui al baño a llorar sola.'
}, {
  initial: 'R',
  color: 'bg-emerald-100 text-emerald-700',
  name: 'Ricardo S.',
  location: 'Buenos Aires',
  child: 'Papá de Benjamín, 8 años',
  text: "Mi hijo me dijo 'papá, soy tonto para leer'. Ese día decidí que tenía que hacer algo diferente. Encontré esto. Hoy, un mes después, él mismo agarra libros sin que nadie se lo pida."
}, {
  initial: 'V',
  color: 'bg-amber-100 text-amber-700',
  name: 'Valeria T.',
  location: 'Tucumán',
  child: 'Mamá de Julieta, 10 años',
  text: 'Probé tres métodos diferentes, dos profesoras particulares y un fonoaudiólogo. Nada terminaba de funcionar. Este sistema me dio algo que ninguno me dio antes: saber exactamente qué hacer yo, con mis manos, en mi casa.'
}];
export function TestimonialsTop() {
  return <section className="py-12 md:py-16 bg-slate-50" data-id="element-302">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-303">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-304">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-white rounded-2xl p-8 shadow-xl shadow-slate-200/50 border border-slate-100 flex flex-col h-full relative" data-id="element-305">
              <div className="flex text-gold mb-6" data-id="element-306">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-307" />)}
              </div>

              <p className="text-slate-700 text-lg leading-relaxed mb-8 flex-grow italic" data-id="element-308">
                "{t.text}"
              </p>

              <div className="flex items-center mt-auto pt-6 border-t border-slate-100" data-id="element-309">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl ${t.color} mr-4 flex-shrink-0`} data-id="element-310">
                  {t.initial}
                </div>
                <div data-id="element-311">
                  <div className="font-bold text-navy" data-id="element-312">{t.name}</div>
                  <div className="text-sm text-slate-500" data-id="element-313">
                    {t.location} · {t.child}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}